export enum SolarVariant {
  'bold' = 'solar-bold',
  'broken' = 'solar-broken',
  'linear' = 'solar-linear',
  'outline' = 'solar-outline',
  'bold-duotone' = 'solar-boldDuotone',
  'line-duotone' = 'solar-lineDuotone',
}

export function isSolarVariant(value: string): value is SolarVariant {
  return (
    value === SolarVariant.bold ||
    value === SolarVariant.broken ||
    value === SolarVariant.linear ||
    value === SolarVariant.outline ||
    value === SolarVariant['bold-duotone'] ||
    value === SolarVariant['line-duotone']
  );
}

export const SolarIconType = 'solar';
